export default "__VITE_ASSET__Derrkzt5__"